// src/components/RequestItem.jsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

export default function RequestItem({ from, age, message, time, photo, type, status }) {
  const isIncoming = type === 'incoming';

  return (
    <div className="bg-white rounded-xl shadow p-4 flex gap-4">
      <img
        src={photo}
        alt={from || 'User'}
        className="w-16 h-16 rounded-full object-cover flex-shrink-0"
      />

      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-start">
          <div>
            <h3 className="font-semibold">
              {from}, {age}
            </h3>
            <p className="text-xs text-gray-500">{time}</p>
          </div>

          {isIncoming && status !== 'decided' && (
            <div className="flex gap-2">
              <button className="w-9 h-9 rounded-full bg-green-100 text-green-600 flex items-center justify-center hover:bg-green-200">
                <FontAwesomeIcon icon={faCheck} />
              </button>
              <button className="w-9 h-9 rounded-full bg-red-100 text-red-600 flex items-center justify-center hover:bg-red-200">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          )}

          {!isIncoming && (
            <span className="text-xs px-2.5 py-1 rounded-full bg-amber-100 text-amber-800">
              {status}
            </span>
          )}
        </div>

        {message && (
          <p className="mt-2 text-sm text-gray-700 line-clamp-2">
            {message}
          </p>
        )}
      </div>
    </div>
  );
}